"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique", "color"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  color: _propTypes.string,
  unique: _propTypes.string
};

var Close = function Close(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "inherit" : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: color,
    fillRule: "evenodd",
    id: "glyphs/nav/close-close" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    fillRule: "nonzero",
    id: "combined-shape-close" + unique,
    xlinkHref: "#path-1-close" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-close" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,10.5857864 L19.4393398,3.14644661 C19.634602,2.95118446 19.9511845,2.95118446 20.1464466,3.14644661 L20.8535534,3.85355339 C21.0488155,4.04881554 21.0488155,4.36539803 20.8535534,4.56066017 L13.4142136,12 L20.8535534,19.4393398 C21.0488155,19.634602 21.0488155,19.9511845 20.8535534,20.1464466 L20.1464466,20.8535534 C19.9511845,21.0488155 19.634602,21.0488155 19.4393398,20.8535534 L12,13.4142136 L4.56066017,20.8535534 C4.36539803,21.0488155 4.04881554,21.0488155 3.85355339,20.8535534 L3.14644661,20.1464466 C2.95118446,19.9511845 2.95118446,19.634602 3.14644661,19.4393398 L10.5857864,12 L3.14644661,4.56066017 C2.95118446,4.36539803 2.95118446,4.04881554 3.14644661,3.85355339 L3.85355339,3.14644661 C4.04881554,2.95118446 4.36539803,2.95118446 4.56066017,3.14644661 L12,10.5857864 Z",
    fill: "inherit",
    id: "path-1-close" + unique
  }))));
};

Close.propTypes = propTypes;
var _default = Close;
exports["default"] = _default;